import * as t from './types'
import * as effects from 'redux-saga/effects'
import * as api from './api'
import { pipe } from 'fp-ts/lib/function'
import { CancelToken } from 'axios'
import { takeLatest, waitForOrganization } from '../../saga'
import { task, option } from 'fp-ts'
import {
  Organization,
  Loading,
  foldEitherToAction,
  NotRequested,
  loadable,
} from '@library/react-toolkit'
import { lens } from 'lens.ts'
import { State } from '../../store'
import { getPayersAction } from '../Payers'

export const initialState: t.State = {
  sendResult: NotRequested,
  importResult: NotRequested,
  addResult: NotRequested,
  viewBill: option.none,
  editBill: option.none,
  mode: 'organization',
  selectedBills: {
    organization: {},
    supplier: {},
  },
  addModalVisible: false,
}

const _l = lens<t.State>()

export const reducer = (s: t.State = initialState, a: t.Actions): t.State => {
  switch (a.type) {
    case 'BILL/send_bill':
      return pipe(s, _l.sendResult.set(Loading))
    case 'BILL/send_bill_result':
      return pipe(s, _l.sendResult.set(a.payload))
    case 'BILL/view_bill':
      return pipe(s, _l.viewBill.set(option.some(a.payload)))
    case 'BILL/close_view_bill':
      return pipe(s, _l.viewBill.set(option.none))
    case 'BILL/edit_bill':
      return pipe(s, _l.editBill.set(option.some(a.payload)))
    case 'BILL/close_edit_bill':
      return pipe(s, _l.editBill.set(option.none))
    case 'BILL/set_mode':
      return { ...s, mode: a.payload }
    case 'BILL/set_selected_bills':
      return {
        ...s,
        selectedBills: { ...s.selectedBills, [s.mode]: a.payload },
      }
    case 'BILL/set_add_modale_visible':
      return { ...s, addModalVisible: a.payload }
    default:
      return s
  }
}

function* sendBillsSaga(
  { payload: { method, ids } }: t.SendBillsAction,
  token?: CancelToken
) {
  const organization: Organization = yield waitForOrganization()
  // @ts-ignore
  yield yield pipe(
    api.sendBills(organization.name, method, ids, token),
    task.map(foldEitherToAction(t.sendBillResultAction)),
    task.map(a => effects.put(a)),
    e => effects.call(e)
  )
}

function* getBillModalDataSaga(_: t.EditBillAction) {
  const d: {
    editBill: State['bills']['editBill']
    payers: State['payers']['payers']
  } = yield effects.select(
    ({ bills: { editBill }, payers: { payers } }: State) => ({
      payers,
      editBill,
    })
  )

  if (option.isNone(d.editBill)) {
    return
  }

  if (loadable.isNotRequested(d.payers.v) || loadable.isErr(d.payers.v)) {
    yield effects.put(getPayersAction({}))
  }
}

export function* saga() {
  yield effects.all([
    takeLatest('BILL/send_bill', sendBillsSaga),
    takeLatest(
      ['BILL/toggle_bill_modal', 'BILL/edit_bill'],
      getBillModalDataSaga
    ),
  ])
}
